namespace TabAurous.OMS {
    export interface ProductTypeRow {
        ProductTypeId?: number;
        ItemTypeId?: number;
        ProductTypeCode?: string;
        ProductTypeName?: string;
        ItemId?: number;
        Narration?: string;
        TaxCode?: string;
        HSN?: string;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
        Purity?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace ProductTypeRow {
        export const idProperty = 'ProductTypeId';
        export const nameProperty = 'ProductTypeName';
        export const localTextPrefix = 'OMS.ProductType';
        export const lookupKey = 'OMS.ProductType';

        export function getLookup(): Q.Lookup<ProductTypeRow> {
            return Q.getLookup<ProductTypeRow>('OMS.ProductType');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            ProductTypeId = "ProductTypeId",
            ItemTypeId = "ItemTypeId",
            ProductTypeCode = "ProductTypeCode",
            ProductTypeName = "ProductTypeName",
            ItemId = "ItemId",
            Narration = "Narration",
            TaxCode = "TaxCode",
            HSN = "HSN",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId",
            Purity = "Purity",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
